/*eslint-disable*/
import React from 'react'
// nodejs library to set properties for components
import PropTypes from 'prop-types'
// nodejs library that concatenates classes
import classNames from 'classnames'
// material-ui core components
import { List, ListItem } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

// @material-ui/icons
import Favorite from '@material-ui/icons/Favorite'

import styles from 'assets/jss/material-kit-react/components/myFooterStyle.js'
import { Link } from 'react-router-dom'

const useStyles = makeStyles(styles)

export default function Footer(props) {
  const classes = useStyles()
  const { whiteFont } = props
  const footerClasses = classNames({
    [classes.footer]: true,
    [classes.footerWhiteFont]: whiteFont,
  })
  const aClasses = classNames({
    [classes.a]: true,
    [classes.footerWhiteFont]: whiteFont,
  })
  return (
    <footer className={footerClasses}>
      <div className={classes.container}>
        <div className={classes.left}>
          <List className={classes.list}>
            <ListItem className={classes.inlineBlock}>
              <Link to="contact" className={classes.block}>
                联系我们
              </Link>
            </ListItem>
            <ListItem className={classes.inlineBlock}>
              <Link to="privacy" className={classes.block}>
                隐私政策
              </Link>
            </ListItem>
          </List>
        </div>
        <div className={classes.right}>
          &copy; 2017-{1900 + new Date().getYear()} 江苏硕佰建筑科技有限公司{' '}
          <a href="http://www.beian.miit.gov.cn/" className={aClasses} target="_blank">
            苏ICP备20030964号-1
          </a>
        </div>
      </div>
    </footer>
  )
}

Footer.propTypes = {
  whiteFont: PropTypes.bool,
}
